import * as apiTypes from './urlShortener.api.types';

import { fetch } from 'fetch';

export const fetchOriginalUrl: apiTypes.GetShortURL = params => {
  return fetch({
    url: '/url_shortener',
    method: 'GET',
    params
  });
};

export const createShortUrl: apiTypes.CreateShortURL = params => {
  return fetch({
    url: '/url_shortener',
    method: 'POST',
    params
  });
};
